<ion-list class="head-list">
  <ion-item size="12" size-sm="12" (click)="clickHead($event)" [ngClass]="expanded ? 'head-item expanded' : 'head-item'">
    <ion-label class="col-panel-head">
      <ng-content select="#collHead"></ng-content>
    </ion-label>
    <ion-icon name="chevron-down-outline" slot="end" *ngIf="type != 'x'" (click)="clickIcon($event)" [ngClass]="expanded ? 'chevron expanded' : 'chevron'">
    </ion-icon>
    <ion-icon name="close-outline" slot="end" *ngIf="type == 'x'" (click)="clickIcon($event)" [ngClass]="expanded ? 'cross expanded' : 'cross'">
    </ion-icon>
  </ion-item>
</ion-list>
<div [ngClass]="'acc-body' + (expanded ? ' expanded' : ' collapsed')" #bodyWrapper>
  <div #container class="acc-container" (click)="clickBody($event)">
    <ng-content select="#collBody"></ng-content>
  </div>
</div>
